import { schedule_types_ids } from "features/Listings/constants/Listings.constants";
import { useFetchCustomCodeOfferings } from "./useFetchCustomCodeOfferings";
import { custom_code_metadata_keys } from "../Codes.config";

export const useFetchCustomCodeBrandedOfferings = ({
  fetch,
  initialData = {},
}) => {
  return useFetchCustomCodeOfferings({
    fetch,
    initialData,
    listingType: schedule_types_ids.branded_community,
    metadataKey: custom_code_metadata_keys.branded_pages,
  });
};
